function appRenamer(apps, clientId){
  return apps.find(app => {
    return (app.clientId === clientId);        
  });
}

export default appRenamer;



// WEBPACK FOOTER //
// ./src/appRenamer.js